module.exports = __webpack_public_path__ + "img/MeterWithFile2.fa8cab09.png";